import { render, staticRenderFns } from "./BibliotecaDigital.vue?vue&type=template&id=599a9b22&scoped=true&"
import script from "./BibliotecaDigital.vue?vue&type=script&lang=js&"
export * from "./BibliotecaDigital.vue?vue&type=script&lang=js&"
import style0 from "./BibliotecaDigital.vue?vue&type=style&index=0&id=599a9b22&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "599a9b22",
  null
  
)

export default component.exports